import axios from "axios";
import { HEADERS } from "../constants/constant";
import { apiRequest, apiGETRequest } from "../utility/Utility";

//Updating PWS Info
export const updatePWSInfo = async (info) => {
  try {
    const response = await apiRequest({
      endpoint: "/watersystems/update-watersystem",
      payload: {
        email: info.email,
        pws_id: info.pwsKey,
        pwsid: info.pwsId,
        main_phone: info.main_phone,
        main_ext: info.main_ext,
        physical_adr: info.physical_adr,
        mailing_adr: info.mailing_adr,
        sampler_trip_type: info.sampler_trip_type,
        sampling_date: info.sampling_date,
        is_acknowledged: info.is_acknowledged,
      },
      returnRaw: true,
    });

    return response.data;
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while updating PWS details: " + error.message,
    };
  }
};

export const uploadFieldFormFile = async (doc, visit, trip, pws_id, wellid) => {
  try {
    await apiRequest({
      endpoint: "/api/uploadFieldFormFile",
      payload: {
        doc: doc,
        visit: visit,
        trip: trip,
        pws_id: pws_id,
        well_id: wellid,
      },
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Success",
      message: "Changes have been saved.",
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message:
        "Error occured while submitting Well Field Form details: " +
        error.message,
    };
  }
};

export const getFieldFormFiles = async (id) => {
  try {
    const response = await apiRequest({
      endpoint: "/api/getFieldFormDocuments",
      payload: {
        visit_id: id,
      },
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Success",
      message: "Files were successfully fetched.",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message:
        "Error occured while fetching field form files: " + error.message,
    };
  }
};

export const submitSamples = async (email, visit_id, samples) => {
  try {
    const response = await apiRequest({
      endpoint: "/api/addSamples",
      payload: {
        email: email,
        visit: visit_id,
        samples: samples,
      },
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Success",
      message: "Added Samples",
      data: response.data,
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while adding samples: " + error.message,
    };
  }
};

export const submitFieldForm = async (data) => {
  try {
    await apiRequest({
      endpoint: "/api/submitFieldForm",
      payload: {
        data: data,
      },
      returnRaw: true,
    });
    return {
      status: 0,
      title: "Success",
      message: "Changes have been saved.",
    };
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message:
        "Error occured while submitting Well Field Form details: " +
        error.message,
    };
  }
};

export const getHomePageStats = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/stats",
      returnRaw: true,
    });

    return response.data;
  } catch (error) {
    return {
      status: -1,
      title: "Error occured",
      message: "Error occured while getting statistics: " + error.message,
    };
  }
};

export const getPWSKeyPersonnelData = async (emailId, pws_id) => {
  return apiGETRequest({
    endpoint: "/watersystems/key-personnel",
    defaultValue: {},
    payload: { emailId, pws_id },
  });
};

export const updatePWSKeyPersonnelData = async (
  adminEmail,
  pwsKey,
  userEmail,
  role,
  action,
) => {
  return apiRequest({
    endpoint: "/watersystems/update-key-personnel",
    defaultValue: {},
    payload: {
      adminEmail,
      pwsKey,
      userEmail,
      role,
      action,
    },
  });
};

export const getVisitDatesByIdentifier = async (identifier) => {
  return apiGETRequest({
    endpoint: "/visits/unconfirmed",
    payload: {
      identifier,
    },
  });
};

export const updateVisitDatesByIdentifier = async (name, data, identifier) => {
  return apiRequest({
    endpoint: "/visits/confirm",
    payload: { name, data, identifier },
  });
};

export const waterSystems = async (pws_id, pwsid, email) => {
  return apiGETRequest({
    endpoint: "/watersystems",
    payload: { pws_id, pwsid, email },
  });
};

export const updateWaterSystem = async (
  pws_id,
  pwsid,
  email,
  main_phone,
  main_ext,
  physical_adr,
  mailing_adr,
) => {
  return apiRequest({
    endpoint: "/watersystems/update-watersystem",
    payload: {
      pws_id: pws_id,
      pwsid: pwsid,
      email: email,
      main_phone: main_phone,
      main_extension: main_ext,
      physical_address: physical_adr,
      mailing_address: mailing_adr,
    },
  });
};

export const addNewVisitBulk = async (
  wells,
  visit_date,
  email,
  sampler_email,
  sampler_type,
) => {
  return apiRequest({
    endpoint: "/visits/bulk-insert",
    payload: {
      wells,
      visit_date,
      email,
      sampler_email,
      sampler_type,
    },
  });
};

export const getWellsForBulkEdit = async (pws_id) => {
  return apiRequest({
    endpoint: "/visits/bulk-edit-view",
    payload: {
      pws_id,
    },
  });
};

export const updateWellsForBulkEdit = async (wells, options) => {
  return apiRequest({
    endpoint: "/visits/bulk-edit-update",
    payload: {
      wells,
      ...options,
    },
  });
};

export const isWaterSystemAcknowledged = async (email, pws_id) => {
  return apiGETRequest({
    endpoint: "/api/isAcknowledged",
    payload: {
      email,
      pws_id,
    },
  });
};

export const bulkDownloadResultNotificationLetters = async (pws_id, pwsId) => {
  try {
    const response = await apiGETRequest({
      endpoint: "/watersystems/download-pws-rnls",
      payload: {
        pws_id,
      },
      config: {
        responseType: "blob",
      },
      returnRaw: true,
    });

    const blob = new Blob([response.data], {
      type: response.headers?.["content-type"] || "application/zip",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${pwsId}_ResultNotificationLetters.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return {
      status: 0,
      title: "Success",
      message: "Result Notification Letters downloaded successfully.",
    };
  } catch (error) {
    console.error("Error downloading RNLs:", error);
    if (error.response && error.response.data instanceof Blob) {
      const errorText = await error.response.data.text();
      const errorJson = JSON.parse(errorText);

      throw new Error(
        errorJson.detail || errorJson.message || "An unknown error occurred.",
      );
    }
    throw error;
  }
};
